import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { Section } from "@/components/Section";
import { KeyIdea } from "@/components/Callouts";

export default function EdSheeran9() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "9");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section title="Chord Chart">
        <NoteImage
          src="/notes/ed-sheeran/finals/09-slowly.png"
          caption="Jason's chord chart for Slowly"
        />
      </Section>

      <Section title="Verse & Chorus Harmony">
        <RomanNumeralAnalysis
          label="Verse · E♭ major"
          chords={[
            { chord: "Eb", rn: "I", function: "Tonic", pitches: ["Eb3", "G3", "Bb3", "Eb4"] },
            { bar: true },
            { chord: "Cm7", rn: "vi7", function: "Submediant", pitches: ["C3", "Eb3", "G3", "Bb3"] },
            { bar: true },
            { chord: "Eb/G", rn: "I⁶", function: "Tonic", pitches: ["G2", "Eb3", "G3", "Bb3"] },
            { chord: "Ab", rn: "IV", function: "Pre-dominant", pitches: ["Ab2", "C3", "Eb3", "Ab3"] },
            { bar: true },
            { chord: "Eb", rn: "I", function: "Tonic", pitches: ["Eb3", "G3", "Bb3", "Eb4"] },
            { chord: "Ebsus4", rn: "Isus4", function: "Tonic", pitches: ["Eb3", "Ab3", "Bb3", "Eb4"] },
            { chord: "Eb", rn: "I", function: "Tonic", pitches: ["Eb3", "G3", "Bb3", "Eb4"] },
          ]}
        />
        <RomanNumeralAnalysis
          label="End of the chorus · E♭ major"
          chords={[
            { chord: "Eb(add2)/G", rn: "I⁶add2", function: "Tonic", pitches: ["G2", "Eb3", "F3", "Bb3"] },
            { chord: "Ab", rn: "IV", function: "Pre-dominant", pitches: ["Ab2", "C3", "Eb3", "Ab3"] },
            { bar: true },
            { chord: "Eb", rn: "I", function: "Tonic", pitches: ["Eb3", "G3", "Bb3", "Eb4"] },
            { chord: "Bb", rn: "V", function: "Dominant", pitches: ["Bb2", "D3", "F3", "Bb3"] },
          ]}
        />
        <KeyIdea title="Special moment">
          Every chord on Jason's chart is diatonic to E♭ major — not one borrowed note. The verse
          never uses the V chord at all: B♭ arrives only at the very end of the chorus.
        </KeyIdea>
      </Section>

      <Section title="Watch">
        <YouTubeEmbed videoId="ctOgZY9zLDM" />
      </Section>
    </LessonShell>
  );
}
